<script>
    import { fade } from "svelte/transition";

    import CodeSelectorManualMbsSurgerySelector from "./CodeSelectorManualMBSSurgerySelector.svelte";

    import {
        getMbsItemNumLabel,
        updateSurgeryItems,
    } from "../../../helpers/mbsHelper.svelte";
    import { apiMethods } from "../../../../../Services/index.svelte";

    import { mbsAllItemsList } from "../../../../../stores";
    import { PageLoading } from "../../../../../Components/Common/index.svelte";
    import { showException } from "../../../../../Utils/utilFunctions.svelte";

    export let itemProps = {},
        doctorId = 0,
        procedureName = "",
        defaultItems = [],
        timeItems = [],
        selectedItems = [],
        updateItems = () => {};

    $: isCardiacEncounter = itemProps.billingType == 3;

    $: if (defaultItems.length) _syncSuggestedItems();

    $: if ($mbsAllItemsList.length) _syncSpecialItems();

    $: if (!isLoadingSuggestedItems && !hasSuggestedItemsFetched)
        loadSurgerySuggestedItems();

    let isAllSurgeryModalOpen = false,
        suggestedItems = [],
        specialItems = [];

    let isLoadingSuggestedItems = false,
        hasSuggestedItemsFetched = false;

    const defaultSurgeryItems = [20142, 20740, 20810]; // Lens, Upper GI endoscopy, Lower GI endoscopy

    const loadSurgerySuggestedItems = async () => {

        isLoadingSuggestedItems = true;

        await apiMethods.getMethod
            .getSurgerySuggestedItems(procedureName, doctorId)
            .then((res) => {
                const itemNums = res?.length
                    ? res.map((r) => r.itemNum)
                    : defaultSurgeryItems;

                suggestedItems = defaultItems.filter((item) =>
                    itemNums.includes(item.itemNum),
                );
            })
            .catch((err) => {
                showException(err);
            });
        isLoadingSuggestedItems = false;

        hasSuggestedItemsFetched = true;
    };

    const handleSelectItem = (item) => {
        updateItems(
            updateSurgeryItems(item, selectedItems, itemProps, specialItems),
        );
    };

    // HELPER FUNCTIONS
    const _syncSuggestedItems = () => {
        suggestedItems = defaultItems.filter(({ itemNum }) =>
            isCardiacEncounter
                ? itemNum == "20560"
                : defaultSurgeryItems.includes(itemNum),
        );
    };

    const _syncSpecialItems = () => {
        const specialModifierItemCodes = [25013, 25014];

        $mbsAllItemsList.map((item) => {
            if (
                item.infoType == "Modifiers" &&
                specialModifierItemCodes.includes(item.itemNum)
            )
                specialItems.push(item);
        });

        if (timeItems.length) specialItems = [...specialItems, ...timeItems];
    };

    const _openAllSurgeryModal = () => (isAllSurgeryModalOpen = true);

    const _closeAllSurgeryModal = () => (isAllSurgeryModalOpen = false);
</script>

<div
    class="flex flex-col gap-y-2 border-2 rounded-md justify-center p-4"
    transition:fade={{ duration: isCardiacEncounter ? 100 : 0 }}
>
    {#if isLoadingSuggestedItems}
        <PageLoading />
    {:else}
        <div class="flex flex-1 items-center justify-between">
            <p class="font-bold text-lg">Surgery</p>

            <button
                class="btn btn-sm btn-secondary"
                on:click|preventDefault={_openAllSurgeryModal}
            >
                View All
            </button>
        </div>

        <p class="text-md text-secondary">Suggested</p>

        <div class="flex flex-col gap-y-2 px-2">
            {#each suggestedItems as item}
                <div class="flex flex-1 items-center justify-between">
                    <div class="flex flex-col">
                        <p class="text-xs">
                            {item.infoRegion}: {item.infoSubRegion}
                        </p>
                        <p class="text md font-bold">
                            {getMbsItemNumLabel(item)}
                            {item.infoShortTitle} ({item.basicUnits})
                        </p>
                    </div>

                    <button
                        class={`w-8 h-8 rounded-full text-[16px] text-[#fff] ${
                            selectedItems.some((itm) => itm.id == item.id)
                                ? "hidden"
                                : "bg-secondary"
                        }`}
                        on:click|preventDefault={() => handleSelectItem(item)}
                    >
                        <i
                            class={`fa-solid ${
                                selectedItems.some((itm) => itm.id == item.id)
                                    ? "fa-minus"
                                    : "fa-plus"
                            }`}
                        />
                    </button>
                </div>
            {/each}
        </div>
    {/if}
</div>

<CodeSelectorManualMbsSurgerySelector
    isModalOpen={isAllSurgeryModalOpen}
    {defaultItems}
    {selectedItems}
    addItem={handleSelectItem}
    closeModal={_closeAllSurgeryModal}
/>
